import { createAction, props } from "@ngrx/store";

export const SET_PERMISSIONS = '[Permissions] Set Permissions';
export const GET_PERMISSIONS = '[Permissions] Get Permissions';

export const setPermissions = createAction(SET_PERMISSIONS, props<{ permissions: string[] }>());
export const getPermissions = createAction(GET_PERMISSIONS, props<{ permissions: string[] }>());
